export default function getAffectedAggregateIds(invokeFunction) {
  return (aggregateTypenames, startDate) =>
    invokeFunction('affected-aggregateids', { aggregateTypenames, startDate });
}
